if (!customElements.get('quick-add-card')) {
  class QuickAddCard extends HTMLElement {
    constructor() {
      super();

      this.fetchConfig = fetchConfig('javascript');
      this.fetchConfig.headers['X-Requested-With'] = 'XMLHttpRequest';

      this.errorMessage = this.dataset.errorMessage || 'Please select options';

      this.handleWindowClickBind = this.handleWindowClick.bind(this);
      this.handleClickBind = this.handleClick.bind(this);
      this.handleChangeBind = this.handleChange.bind(this);
    }

    connectedCallback() {
      this.form = this.querySelector('.quick-add-card__form');
      this.dropdownTriggers = this.querySelectorAll('.quick-add-card__variant-dropdown-trigger');
      this.dropdownContainers = this.querySelectorAll('.quick-add-card__variant-dropdown');
      this.error = this.querySelector('.quick-add-card__error');

      window.addEventListener('click', this.handleWindowClickBind);
      this.addEventListener('click', this.handleClickBind);
      this.addEventListener('change', this.handleChangeBind);
    }

    disconnectedCallback() {
      window.removeEventListener('click', this.handleWindowClickBind);
      this.removeEventListener('click', this.handleClickBind);
      this.removeEventListener('change', this.handleChangeBind);
    }

    handleChange(evt) {
      const variantRadio = evt.target.closest('.quick-add-card__variant-input');
      if (variantRadio) {
        this.closeDropDowns();
        this.updateShadeSelection(evt.target);
      }
    }

    handleWindowClick(evt) {
      const parentCard = evt.target.closest('.quick-add-card');
      if (parentCard !== this) {
        this.closeDropDowns();
      }
    }

    handleClick(evt) {
      const atcButton = evt.target.closest('.quick-add-card__form-submit');
      const dropDownTrigger = evt.target.closest('.quick-add-card__variant-dropdown-trigger');

      this.closeDropDowns();

      if (dropDownTrigger) {
        this.openDropdown(dropDownTrigger);
      }

      if (atcButton) {
        evt.preventDefault();
        const formValid = this.validate();
        if (formValid) {
          this.errorUpdate('');
          this.atc(atcButton);
        } else {
          this.errorUpdate(this.errorMessage);
        }
      }
    }

    updateShadeSelection(input) {
      const title = input.getAttribute('data-variant-title');
      const color = input.getAttribute('data-shade-color');
      const parentWrapper = input.closest('.quick-add-card__variant-dropdown-wrapper');
      const button = parentWrapper?.querySelector('.quick-add-card__variant-dropdown-trigger');
      const parentDropdown = input.closest('.quick-add-card__variant-dropdown');

      if (parentDropdown) {
        parentDropdown.classList.remove('quick-add-card__variant-dropdown--error');
      }

      if (button && title) {
        button.innerHTML = '';

        let buttonInnerHTML = '';

        if (color) {
          button.style.setProperty('--shade-color', color);
          buttonInnerHTML = '<span class="quick-add-card__variant-dropdown-trigger-shade"></span>';
        }

        buttonInnerHTML += `<span class="quick-add-card__variant-dropdown-trigger-title">${title}</span>`;
        button.innerHTML = buttonInnerHTML;
      }
    }

    validate() {
      let isValid = true;
      this.dropdownContainers.forEach(dropdownContainer => {
        const checkedVariant = dropdownContainer.querySelector('.quick-add-card__variant-input:checked');

        dropdownContainer.classList.toggle(
          'quick-add-card__variant-dropdown--error',
          !checkedVariant
        );

        isValid = !!checkedVariant;
      });
      return isValid;
    }

    errorUpdate(message = '') {
      if (this.error) {
        this.error.innerHTML = message;
      }
    }

    closeDropDowns() {
      this.dropdownTriggers.forEach((dropdown) => dropdown.setAttribute('aria-expanded', false));
      this.dropdownContainers.forEach((dropdown) => dropdown.setAttribute('aria-hidden', true));
    }

    openDropdown(button) {
      button.setAttribute('aria-expanded', true);
      const selectedDropdown = this.querySelector(`#${button.getAttribute('aria-controls')}`);
      if (selectedDropdown) {
        selectedDropdown.setAttribute('aria-hidden', false);
      }
    }

    atc() {
      const formData = new FormData(this.form);
      const formDataArray = Array.from(formData.entries());

      let sellingPLan = formData.get('selling_plan');

      let itemArray = [];

      formDataArray.forEach(entry => {
        if (!entry[0].startsWith('variant') && entry[0] !== 'free_item') {
          return;
        }

        let newItem = {
          quantity: 1,
          id: entry[1]
        };

        if (!!sellingPLan) {
          if (entry[0].startsWith('variant')) {
            newItem.selling_plan = sellingPLan;
          }
        }

        itemArray.push(newItem);
      });

      if (itemArray.length > 0) {
        document.body.classList.add('hide-upcart');
        this.fetchConfig.body = JSON.stringify({ 'items': itemArray });
        fetch(routes.cart_add_url, this.fetchConfig)
          .then((response) => {
            if (response.ok) {
              window.location.href = '/checkout';
            }
          })
          .catch((error) => {
            console.error('Error:', error);
            document.body.classList.remove('hide-upcart');
          });
      }
    }
  }

  customElements.define('quick-add-card', QuickAddCard);
}
